import { IonHeader, IonTitle, IonToolbar } from "@ionic/react";
import { Loader } from "components";

import { FilterBar } from "~components/Organisms/IndexFilters";
import { initialLocalStorageFilterValues } from "~components/Organisms/IndexFilters/types";
import { translate, useLocalStorage } from "~utils";

import { useRequestIndexFilters, useRequests } from "./hooks";
import { RequestCount } from "./RequestCount";
import { RequestIndex } from "./RequestIndex";

export function ActiveRequestsPage() {
  const { data, isError } = useRequests({
    showHistory: false,
  });

  const [ls, setLs] = useLocalStorage(
    "swing-schools:filters:active",
    initialLocalStorageFilterValues,
  );

  const filteredRequests = useRequestIndexFilters(ls, data?.requests);

  if (!data) return <Loader />;

  return (
    <>
      <IonHeader collapse="condense">
        <IonToolbar>
          <IonTitle size="large">{translate("ROUTE_TABLE_ACTIVE_REQUESTS")}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <FilterBar page="active" ls={ls} setLs={setLs}></FilterBar>
      <RequestCount page="active" count={filteredRequests.length} />
      <RequestIndex requestType="active-requests" requests={filteredRequests} isError={isError} />
    </>
  );
}
